import http from './http';

export default class EventLogService {
  static addLogs(data) {
    return http.post('/eventlog', data);
  }
  static getSupplierLogs(supplierId, days) {
    return http.get(`/eventlog/supplier/${supplierId}${days ? `?days=${days}` : ''}`);
  }
}